import styled from 'styled-components'

export const SelectorLayout = styled.div`
  min-width: 327px;
`

SelectorLayout.displayName = 'SelectorLayout'
